import React, { useEffect, useState } from 'react'
import NavbarMob from './NavbarMob'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';



function MyInfo() {
    const [userData, setUserData] = useState({
        full_name: '',
        email: '',
        password: '',
        mobile: ''
    });

    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [addressLoading, setAddressLoading] = useState(true);
    const [error, setError] = useState(null);
    const [addressError, setAddressError] = useState(null);
    const navigate = useNavigate()
    const userId = useSelector((state) => state.user.id);
    const LedCode = localStorage.getItem('LedCode');
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const fetchUserData = async () => {
        try {
            const response = await axios.get(`${apiBaseUrl}/user/getCustomerById/BLACKBATON_2526/${LedCode || userId}`);
            if (response.data.success) {
                setUserData(response.data.data);
            } else {
                setError('User not found');
            }
        } catch (err) {
            setError('Please Login First');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {


        fetchUserData();
    }, [LedCode, userId, apiBaseUrl]);

    // Fetch addresses
    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const response = await axios.get(`${apiBaseUrl}/user/getAddresses/BLACKBATON_2526/${LedCode || userId}`);
                if (response.data.success) {
                    setAddresses(response.data.data); // Store fetched addresses
                } else {
                    setAddressError('No addresses found');
                }
            } catch (err) {
                setAddressError('Error fetching addresses');
                console.error(err);
            } finally {
                setAddressLoading(false);
            }
        };

        fetchAddresses();
    }, [LedCode, userId, apiBaseUrl]);


    const homePage = () => {
        navigate('/')
    }
    const accountPage = () => {
        navigate('/account')
    }
    const forgotpassword = () => {
        navigate('/forgotpass')
    }

    const addresspage = () => {
        navigate('/address')
    }

    const [changeMob, setChangeMob] = useState(false)
    const [changeEmail, setChangeEmail] = useState(false)
    const [changeName, setChangeName] = useState(false)
    const [mobile, setMobile] = useState('')
    const [email, setEmail] = useState('')
    const [fullName, setFullName] = useState('')

    const changemobilenum = () => {
        setChangeMob(true)
        setChangeEmail(false)
        setEmail('')
    }

    const changeEmailAddress = () => {
        setChangeEmail(true)
        setChangeMob(false)
        setMobile('')
    }

    const changeFullName = () => {
        setChangeName(true)
        setFullName(userData.full_name || '')
    }

    const handleChangeName = async () => {
        try {
            const response = await fetch(
                `${apiBaseUrl}/user/changeName/BLACKBATON_2526/${LedCode || userId}`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ full_name: fullName })
                }
            );
            const data = await response.json();
            if (data.success) {
                localStorage.setItem('loginName', fullName || '');
                setChangeName(false);
                fetchUserData();
            } else {
                toast.info(data.error || 'Failed to update name');
            }
        } catch (err) {
            console.error(err);
            toast.info('Failed to update name');
        }
    }

    // const handleChanegNum = async () => {

    //     try {
    //         const response = await axios.post(`${apiBaseUrl}/user/changeMobileNum/BLACKBATON_2526/${LedCode || userId}/${mobile}`);
    //         if (response.data.success) {
    //             fetchUserData()
    //         } else {
    //             toast.info('Mobile number already exist.')
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     }
    // }

    const [showOtp, setShowOtp] = useState(false);
    const [content, setContent] = useState('');

    const handleChanegNum = async () => {

        if (!mobile) {
            setChangeMob(false)
            return toast.info('Please enter mobile number')
        }

        const res = await fetch(
            `${apiBaseUrl}/user/changeMobileNum/BLACKBATON_2526/${LedCode || userId}/${mobile}/${userData.full_name}`,
            {
                method: "POST", headers: { "Content-Type": "application/json" }
            }
        );
        const data = await res.json();

        if (data.success) {
            setShowOtp(true);
            setContent('Changing Mobile')
        }
        else toast.info(data.error);
    };


    const isValidEmail = (value) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(value);
    };

    const handleChangeEmail = async () => {

        if (!email) {
            setChangeEmail(false)
            return toast.info('Please enter email address');
        }

        if (!isValidEmail(email)) {
            setChangeEmail(false)
            return toast.info('Please enter a valid email address');
        }

        const res = await fetch(
            `${apiBaseUrl}/user/changeEmail/BLACKBATON_2526/${LedCode || userId}/${email}`,
            {
                method: "POST", headers: { "Content-Type": "application/json" }
            }
        );
        const data = await res.json();

        if (data.success) {
            setShowOtp(true);
            setContent('Changing Email')
        }
        else toast.info(data.error);
    };

    const verifyOtp = async (otp) => {
        const res = await fetch(`${apiBaseUrl}/user/verifyNumChangeOtp/BLACKBATON_2526/${LedCode || userId}/${mobile}/${otp}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" }
        });
        const data = await res.json();

        if (data.success) {
            toast.info("Mobile updated!");
            setShowOtp(false);
            fetchUserData()
            setChangeMob(false)
        } else {
            toast.info(data.error);
        }
    };

    const verifyEmailOtp = async (otp) => {
        const res = await fetch(`${apiBaseUrl}/user/verifyEmailOtp`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                cId: "BLACKBATON_2526",
                id: LedCode || userId,
                email,
                otp
            })
        });

        const data = await res.json();

        if (data.success) {
            toast.info("Email updated successfully");
            setShowOtp(false);
            fetchUserData()
            setChangeEmail(false)
        } else {
            toast.info(data.error);
        }
    };


    const OtpModal = ({ open, content, onClose, onVerify }) => {
        const [otp, setOtp] = useState("");

        if (!open) return null;

        return (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                <div className="bg-white p-6 rounded w-80">
                    <h2 className="text-lg font-semibold mb-3">Verify OTP for {content}</h2>

                    <input
                        type="text"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                        className="border w-full p-2 mb-4"
                        placeholder="Enter 6 digit OTP"
                    />

                    <div className="flex justify-end gap-2">
                        <button onClick={onClose} className="px-4 py-2 border rounded">
                            Cancel
                        </button>
                        <button
                            onClick={() => onVerify(otp)}
                            className="px-4 py-2 bg-blue-600 text-white rounded"
                        >
                            Verify
                        </button>
                    </div>
                </div>
            </div>
        );
    };



    if (loading || addressLoading) {
        return <div>Loading...</div>;
    }

    if (error || addressError) {
        return <div>{error || addressError}</div>;
    }

    return (
        <div className='w-full h-auto flex flex-col gap-4 text-start'>
            <div className='md:hidden flex'>
                <NavbarMob />
            </div>
            <span className='text-3xl font-[700] font-montserrat lg:flex hidden'>My Info</span>
            <span className='text-2xl font-[600] font-montserrat text-[#3C4242] lg:flex hidden'>Contact Details</span>
            <div className='flex flex-col w-full lg:mt-0 mt-[60px] lg:px-0 px-3 '>
                <div className='flex flex-row gap-2 items-center mt-3 md:hidden'>
                    <span className='text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={homePage}>Home</span>
                    <span className='text-[#828282]'>{">"}</span>
                    <span className='text-xs font-[400] font-montserrat text-[#3C4242]' onClick={accountPage}>Account</span>
                    <span className='text-[#828282]'>{">"}</span>
                    <span className='text-xs font-[400] font-montserrat text-[#3C4242]'>My Profile</span>

                </div>
                <div className='flex flex-col gap-3 mt-3 lg:hidden'>
                    <span className='lg:text-3xl text-base font-[700] font-montserrat  '>My Info</span>
                    <span className='lg:text-2xl text-sm font-[600] font-montserrat text-[#3C4242]  '>Contact Details</span>

                </div>

                <div className='w-full flex flex-col py-3 border-b-2 border-[#EDEEF2] gap-1 lg:mt-0 mt-3'>
                    <span className='lg:text-lg text-sm font-[700] font-montserrat'>Your Name</span>
                    <div className='flex justify-between items-center'>
                        {changeName ? (
                            <input
                                type="text"
                                className="border-2 border-[#EDEEF2] p-1"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                            />
                        ) : (
                            <span className='lg:text-lg text-sm font-[400] font-montserrat'>{userData.full_name || 'Not set'}</span>
                        )}
                        {changeName ? (
                            <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={handleChangeName}>Save</span>
                        ) : (
                            <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={changeFullName}>{userData.full_name ? 'Change' : 'Add'}</span>
                        )}
                    </div>
                </div>

                <div className='w-full flex flex-col py-3 border-b-2 border-[#EDEEF2] gap-1'>
                    <span className='lg:text-lg text-sm font-[700] font-montserrat'>Email Address</span>

                    <div className='flex justify-between items-center'>
                        {changeEmail ? (
                            <input
                                type="email"
                                className="border-2 border-[#EDEEF2] p-1"
                                value={email}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setEmail(value);
                                }}
                            />


                        ) : (
                            <span className='lg:text-lg text-sm font-[400] font-montserrat'>{userData.email || 'Not registered'}</span>
                        )}

                        {changeEmail ? (
                            <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={handleChangeEmail}>Save</span>
                        ) : (
                            <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={changeEmailAddress}>{userData.email ? 'Change' : 'Add'}</span>
                        )}

                    </div>
                </div>

                <div className='w-full flex flex-col py-3 border-b-2 border-[#EDEEF2] gap-1'>
                    <span className='lg:text-lg text-sm font-[700] font-montserrat'>Mobile Number</span>
                    <div className='flex justify-between items-center'>
                        {changeMob ? (
                            <input
                                type="text"
                                className="border-2 border-[#EDEEF2] p-1"
                                value={mobile}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, ""); // only digits
                                    if (value.length <= 10) {
                                        setMobile(value);
                                    }
                                }}
                                maxLength={10}
                            />

                        ) : (
                            <span className='lg:text-lg text-sm font-[400] font-montserrat'>{userData.mobile || 'Not registered'}</span>
                        )}

                        {changeMob ? (
                            <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={handleChanegNum}>Save</span>
                        ) : (
                            <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={changemobilenum}>{userData.mobile ? 'Change' : 'Add'}</span>
                        )}

                    </div>
                </div>


                <div className='w-full flex flex-col py-3 border-b-2 border-[#EDEEF2] gap-1'>
                    <span className='lg:text-lg text-sm font-[700] font-montserrat'>Password</span>
                    <div className='flex justify-between items-center'>
                        <span className='lg:text-lg text-sm font-[400] font-montserrat'>{userData.password}</span>
                        <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={forgotpassword}>Change</span>
                    </div>
                </div>

                <div className='w-full flex flex-col py-3 lg:gap-12 gap-6'>
                    <div className='flex justify-between items-center'>
                        <span className='lg:text-lg text-sm font-[700] font-montserrat'>Address</span>
                        <span className='lg:text-lg text-sm font-[600] font-montserrat text-[#3C4242] cursor-pointer' onClick={addresspage}>Add New</span>

                    </div>
                    <div className='flex w-full lg:flex-row flex-col items-center h-[300px] gap-4 '>
                        {addresses.map((address, index) => (
                            <div key={index} className='lg:w-1/2 w-full h-full rounded-[12px] bg-[#F6F6F6] p-6 flex flex-col gap-3'>
                                <span className='lg:text-xl text-base font-[600] font-montserrat'>{address.name}</span>
                                <span className='text-sm font-[500] font-montserrat text-[#807D7E]'>{address.mobile}</span>
                                <span className='text-sm font-[500] font-montserrat text-[#807D7E]'>{address.address}, {address.locality}, {address.city}, {address.district} - {address.pincode}</span>
                                <div className='flex flex-row h-[34px] gap-4'>
                                    <div className='h-full w-auto px-3 flex justify-center items-center rounded-[8px] border-2 border-[#909090] text-sm font-[600] font-montserrat text-[#807D7E]'>
                                        {address.addressType}
                                    </div>
                                    {address.isActive && (
                                        <div className='h-full w-auto px-3 flex justify-center items-center rounded-[8px] border-2 border-[#909090] text-sm font-[600] font-montserrat text-[#807D7E]'>
                                            Default billing address
                                        </div>
                                    )}
                                </div>
                                <div className='lg:flex hidden'>
                                    <br />

                                </div>

                            </div>
                        ))}

                    </div>

                </div>
            </div>

            <OtpModal
                open={showOtp}
                content={content}
                onClose={() => setShowOtp(false)}
                onVerify={changeEmail ? verifyEmailOtp : changeMob && verifyOtp}
            />
        </div>
    )
}

export default MyInfo



